var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disease-trend-chart"},[_c('Title',{attrs:{"type":"特殊","title":"贴敷复诊率"},on:{"setting-click":_vm.handleSetting}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"trend-chart",attrs:{"id":"diseaseTrendChart"}})])
}]

export { render, staticRenderFns }